function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M474,255.6c.22,116.12-94.48,211.07-210.6,211.15A209.86,209.86,0,0,1,131,420.09a20.38,20.38,0,0,1-1.57-30.26l9.58-9.58a20.44,20.44,0,0,1,27.1-1.68,156.37,156.37,0,1,0-10-236.5l43.13,43.13a13.6,13.6,0,0,1-9.62,23.21H66.1a13.6,13.6,0,0,1-13.6-13.6V71.28a13.6,13.6,0,0,1,23.21-9.62l42,42A210,210,0,0,1,263.25,45.25C379.51,45.25,473.79,139.39,474,255.6Zm-153.74,67,8.35-10.73A20.4,20.4,0,0,0,325,283.2l-34.59-26.9V167.62a20.39,20.39,0,0,0-20.39-20.39h-13.6a20.39,20.39,0,0,0-20.39,20.39V282.9l55.58,43.23A20.4,20.4,0,0,0,320.26,322.55Z"
});

var SvgHistory = function SvgHistory(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history.06eb7032.svg";
export { ForwardRef as ReactComponent };